import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { isAuthenticated } from '../../service/axios';

const STORAGE_KEY = 'servicos_onboarding_done';

function getStoredStatus(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

function markDone() {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    // storage unavailable
  }
}

function broadcastToIframes(type: string) {
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    iframe.contentWindow?.postMessage({ type }, '*');
  });
}

export function isServicosOnboardingDone(): boolean {
  return getStoredStatus();
}

export function useServicosOnboarding() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isAuthenticated()) return;
    if (getStoredStatus()) return;
    setVisible(true);
  }, []);

  const confirm = useCallback(() => {
    markDone();
    setVisible(false);
    // iframe (modo legado) + própria janela (bookstore embutida como rota interna)
    broadcastToIframes('PARTIU_SERVICOS_ONBOARDING_DONE');
    window.postMessage({ type: 'PARTIU_SERVICOS_ONBOARDING_DONE' }, '*');
  }, []);

  return { visible, confirm };
}

export function OnboardingBalloon({
  text,
  onConfirm,
  arrowLeft = '50%',
  menuHeight = '75px',
}: {
  text: string;
  onConfirm: () => void;
  arrowLeft?: string;
  menuHeight?: string;
}) {
  return (
    <>
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={menuHeight}
        bg="blackAlpha.600"
        zIndex={1399}
        onClick={(e) => e.stopPropagation()}
      />
      <Box
        position="fixed"
        left="5%"
        right="5%"
        bottom={`calc(${menuHeight} + 14px)`}
        zIndex={1400}
      >
        <VStack
          bg="white"
          borderRadius="16px"
          padding="24px 20px"
          spacing={4}
          boxShadow="0 8px 32px rgba(0,0,0,0.18)"
          textAlign="center"
          border="2px solid"
          borderColor="blue.400"
          position="relative"
        >
          <Text fontSize="15px" fontWeight="600" color="gray.800" lineHeight="1.5" maxW="400px">
            {text}
          </Text>
          <Button colorScheme="blue" borderRadius="10px" px={10} size="md" onClick={onConfirm}>
            OK
          </Button>
          <Box
            position="absolute"
            bottom="-12px"
            left={arrowLeft}
            transform="translateX(-50%)"
            w={0}
            h={0}
            borderLeft="10px solid transparent"
            borderRight="10px solid transparent"
            borderTop="12px solid"
            borderTopColor="blue.400"
          />
        </VStack>
      </Box>
    </>
  );
}
